import React from "react";
import {
    Box,
    Grid,
    Button,
    TextField,
    Typography,
    Table,
    TableRow,
    TableBody,
    TableCell,
    CircularProgress,
} from "@mui/material";
import {useCardStyles} from "../../constants/styles";
import agent from "../../../../../agent/agent";

const VinDecoder = () => {
    const classes = useCardStyles();
    const [vin, setVin] = React.useState("");
    const [result, setResult] = React.useState(null);
    const [isLoading, setLoading] = React.useState(false);
    const [error, setError] = React.useState("");

    const handleDecode = async () => {
        if (vin.length !== 17) {
            setError("VIN должен содержать 17 символов");
            return;
        }
        setError("");
        setLoading(true);
        setResult(null);

        const res = await agent.get(`/vin-dictionary/decode?vin=${vin}`)
            .then((res) => res.data)
            .catch((err) => ({error: err.response?.data?.message || "Ошибка декодирования"}));

        if (res?.error) {
            setError(res.error);
            setLoading(false);
            return;
        }
        setResult(res);
        setLoading(false);
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleDecode();
        }
    };

    return (
        <Box className={classes.root}>
            <Typography variant="h3" textAlign="left" mb={2}>Декодирование VIN</Typography>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={6}>
                    <TextField
                        value={vin}
                        size="small"
                        label="VIN-номер (17 символов)"
                        placeholder="Например: SALLSAA349A198127"
                        fullWidth
                        inputProps={{maxLength: 17, style: {textTransform: "uppercase"}}}
                        onChange={(e) => setVin(e.target.value.toUpperCase())}
                        onKeyPress={handleKeyPress}
                    />
                </Grid>
                <Grid item>
                    <Button
                        variant="contained"
                        size="small"
                        disabled={vin.length !== 17 || isLoading}
                        onClick={handleDecode}
                        sx={{height: 40}}
                    >
                        {isLoading ? <CircularProgress size={20} color="inherit"/> : "Расшифровать"}
                    </Button>
                </Grid>
            </Grid>

            {error && (
                <Typography color="error" mt={1}>{error}</Typography>
            )}

            {result && (
                <Table size="small" sx={{marginTop: "16px"}}>
                    <TableBody>
                        <TableRow>
                            <TableCell sx={{fontWeight: "bold", width: 200}}>VIN</TableCell>
                            <TableCell>{result.normalized_vin}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell sx={{fontWeight: "bold"}}>Марка</TableCell>
                            <TableCell>{result.brand_label || "—"}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell sx={{fontWeight: "bold"}}>Модель</TableCell>
                            <TableCell>{result.model_label || "—"}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell sx={{fontWeight: "bold"}}>Модельный год</TableCell>
                            <TableCell>
                                {result.model_year_resolved || "—"}
                                {result.model_year_code && <span style={{color: "#8698B1"}}> (код: {result.model_year_code})</span>}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell sx={{fontWeight: "bold"}}>Двигатель</TableCell>
                            <TableCell>
                                {result.engine_label || "—"}
                                {result.engine_code && <span style={{color: "#8698B1"}}> (код: {result.engine_code})</span>}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            )}
        </Box>
    );
};

export default VinDecoder;
